export default __webpack_public_path__ + "static/media/conda-forge.923a4343.png";